export function gcsUriToHttps(uri: string): string {
  if (!uri) return uri;
  if (uri.startsWith("gs://")) {
    const withoutScheme = uri.slice("gs://".length);
    const firstSlash = withoutScheme.indexOf("/");
    if (firstSlash === -1) {
      return `https://storage.cloud.google.com/${withoutScheme}`;
    }
    const bucket = withoutScheme.slice(0, firstSlash);
    const path = withoutScheme.slice(firstSlash + 1);
    return `https://storage.cloud.google.com/${bucket}/${path}`;
  }
  return uri;
}
